import React from "react";
import PropTypes from "prop-types";

import { createPortal } from "react-dom";
import { Overlay } from "components";
import cuid from "cuid";

const propTypes = {
  children: PropTypes.shape({
    btn: PropTypes.func.isRequired,
    window: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  }),
  location: PropTypes.object,
  orientation: PropTypes.oneOf(["left", "right"]),
  offsetTop: PropTypes.number,
  fixed: PropTypes.bool.isRequired,
};

const defaultProps = {
  offsetTop: 0,
  orientation: "left",
  fixed: false,
};

type State = {
  top: ?number,
  right: ?number,
  left: ?number,
};

class Popover extends React.Component<any, State> {
  constructor(props) {
    super(props);
    this.id = cuid();
    this.node = null;
    this.hook = document.getElementById("overlay");
    this.html = document.documentElement;
    this.actions.open = this.actions.open.bind(this);
    this.actions.close = this.actions.close.bind(this);
    this.overflowChecker = this.overflowChecker.bind(this);
    this.left = props.orientation === "left";
    this.right = props.orientation === "right";
    this.offsetTop = props.offsetTop;
    this.fixed = props.fixed;
  }

  componentDidUpdate(oldProps) {
    if (this.props.location !== oldProps.location) {
      this.setState({ top: null, right: null, left: null });
    }
  }

  componentDidMount() {
    this.node = document.getElementById(this.id);
  }

  overflowChecker() {
    if (!this.target) return false;
    const rect = this.target.getBoundingClientRect();
    const crossRight = rect.right > this.html.clientWidth;
    // const crossLeft = rect.left < 0;
    if (crossRight) this.setState({ left: this.html.clientWidth - rect.width });
    // if(crossLeft) this.setState({ right: this.html.clientWidth - -rect.left }) // TODO
  }

  state = { top: null, right: null, left: null };

  actions = {
    open(): void {
      window.addEventListener("resize", this.overflowChecker);
      const rect = this.node.getBoundingClientRect();
      this.setState(
        {
          top: rect.top + this.html.scrollTop + this.offsetTop,
          left: rect.left,
          right: this.html.clientWidth - rect.right,
        },
        this.overflowChecker
      );
    },
    close(): void {
      window.removeEventListener("resize", this.overflowChecker);
      this.setState({ top: null, right: null, left: null });
    },
  };

  getTargetRef = ref => {
    this.target = ref;
  };

  renderWindow() {
    // component can render content as node or function;
    // function is required for passing ref, which is required
    // to handle window resize event
    const { children } = this.props;
    if (typeof children.window === "function") {
      return children.window();
    }
    return children.window;
  }

  render() {
    const { children } = this.props;
    const { top, right, left } = this.state;

    let styles = {};
    if (top) {
      styles = {
        display: "block",
        top: this.fixed ? this.offsetTop : top + 30,
        left: this.left ? undefined : left,
        right: this.right ? undefined : right,
        zIndex: 3,
        position: this.fixed ? "fixed" : "absolute",
      };
    }

    return (
      <React.Fragment>
        <div id={this.id}>
          {children.btn(this.actions.open, { close: this.actions.close, isOpen: top !== null })}
        </div>
        {top !== null &&
          createPortal(
            <Overlay close={this.actions.close}>
              <div style={styles} ref={this.getTargetRef}>
                {this.renderWindow()}
              </div>
            </Overlay>,
            this.hook
          )}
      </React.Fragment>
    );
  }
}

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
export default Popover;

// how to use:

// <Popover orientation="right" offsetTop={33}>
//   {{
//     btn: (open) => (
//     <button onClick={open}>
//       ...
//     </button>
//   ), window: <div />}}
// </Popover>

// to close popover on location change just pass location as a prop



// WEBPACK FOOTER //
// ./src/components/Popover.jsx